import { MutableRefObject } from 'react';
import GameEngine from 'react-game-engine';

import { Dim, Entity } from '../../models';
import RecordPad from '../renderers/RecordPad';
import { getPanelDims } from '../../helpers';

export default (
  windowDims: Dim,
  gameEngineRef: MutableRefObject<GameEngine>
): Entity => {
  const panelDims = getPanelDims(windowDims).jog;
  const panelS = 2 * (panelDims.b ?? 0) + 2 * (panelDims.m ?? 0);
  const panelWidth = panelDims.w + panelS;
  const panelHeight = panelDims.h + panelS;

  return {
    dims: { w: panelWidth, h: panelHeight },
    getPos: () => ({
      x: windowDims.w / 2,
      y: windowDims.h - (3 * panelHeight) / 2,
    }),
    panelDims,
    gameEngineRef,
    renderer: RecordPad,
  };
};
